import { Button, FormModifier, IconLogoMark, Link } from '@hudl/uniform-ui-components';
import React, { useEffect, useRef } from 'react';
import { LoginResponse } from 'requests/rest/login';
import * as styles from './styles.scss';

interface LoginFormProps {
  email: string;
  forward?: string | null;
  initialError?: string;
  hudlLogoClassName?: string;
  formClassName?: string;
  setEmail: (email: string) => void;
  onLogin: (email: string, password: string, rememberMe: boolean) => Promise<LoginResponse>;
  onHelpClick: () => void;
}

const LausdOrgLoginForm = (props: LoginFormProps, clientId: string) => {
  const { forward, hudlLogoClassName, formClassName} = props;

  const emailRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    emailRef?.current?.focus();
  }, [emailRef]);

  const ssoUrl = new URL('https://www.hudl.com', window.location.origin);
  if (forward) {
    ssoUrl.searchParams.append('forward', forward);
  }
  if (clientId) {
    ssoUrl.searchParams.append('client_id', clientId);
  }

  return (
    <form className={styles.formContainer}>
      <Link href="/" type="wrapper" className={`${styles.hudlLogoContainer} ${hudlLogoClassName ?? ''}`}>
        <IconLogoMark qaId="hudl-logo" size="large" />
      </Link>

      <FormModifier
        className={`${styles.formModifierContainer} ${formClassName ?? ''}`}
        formSize="large"
        density="default">
        <Link href={ssoUrl.toString()} className="uni-margin--three--bottom" type="wrapper">
          <Button
            buttonType="subtle"
            buttonStyle="minimal"
            size="large"
            className={styles.logInWithAnOrganizationButton}
            qaId="log-in-with-organization-btn">
            Login with your Organization
          </Button>
        </Link>
      </FormModifier>
    </form>
  );
};

export default LausdOrgLoginForm;
